import styled from 'styled-components';

export const DefaultContainerCard = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 350px;
  padding: 50px 0 30px 0;
  border-radius: 10px;
  background: linear-gradient(
    160deg,
    rgba(163, 27, 27, 0.12) 0%,
    rgba(0, 0, 0, 0.3) 100%
  );
  border: 1px solid rgba(163, 27, 27, 0.35);
  color: white;
  margin-bottom: 24px;
  overflow: hidden;
`;

interface TopDecorColorProps {
  height?: string;
  borderRadius?: string;
  borderTopLeftRadius?: string;
  borderTopRightRadius?: string;
}

export const TopDecorColor = styled.div<TopDecorColorProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(163, 27, 27, 0.7) 40%,
    rgba(163, 27, 27, 0.7) 60%,
    transparent 100%
  );
  overflow: hidden;
`;

export const BoxWinnerGeneric = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.75);
  border-top: 2px solid gold;
  overflow: hidden;
  color: #fff;
  padding: 4px 14px;

  & .by-dq {
    font-size: 10px;
    font-weight: 600;
    margin-top: -8px;
    color: rgba(255, 215, 0, 0.85);
  }

  & .winner-text {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: 3px;
    color: #fff;
  }

  &.small {
    padding: 2px 6px;

    & .winner-text {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 1px;
    }

    & .by-dq {
      font-size: 7px;
      margin-top: -3px;
    }
  }

  &.box-winner-generic-nwo,
  &.box-winner-generic-six,
  &.box-winner-generic-w-100 {
    padding: 1px 4px;

    & .winner-text {
      font-size: 9px;
      font-weight: 700;
      letter-spacing: 0.5px;
    }

    & .by-dq {
      font-size: 6px;
      margin-top: -2px;
    }
  }

  &.box-winner-generic-rumble {
    & .winner-text {
      font-size: 7px;
      font-weight: 500;
    }
  }
`;

export const CenterInfoFight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  border-left: 1px solid rgba(255, 255, 255, 0.12);

  & .info-fight-title {
    text-transform: capitalize;
    color: rgba(255, 255, 255, 0.85);
  }

  & .notes-title {
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 10px;
    font-style: italic;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
  }

  & .no-contest-title {
    color: #ff6b6b;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 1px;
  }
`;

interface AvatarOpponentBoxAvatarProps {
  width?: string;
  height?: string;
}

export const AvatarOpponentBoxAvatar = styled.div<AvatarOpponentBoxAvatarProps>`
  position: relative;
  width: ${(props) => props.width || '200px'};
  height: ${(props) => props.height || '200px'};
  border: 2px solid rgba(163, 27, 27, 0.45);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  overflow: hidden;

  &:hover {
    border-color: rgba(163, 27, 27, 0.85);
    box-shadow: 0 0 12px rgba(163, 27, 27, 0.25);
    transform: scale(1.04);
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    display: block;
  }
`;

export const BeltImg = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: top;
  filter: drop-shadow(0 2px 6px rgba(255, 215, 0, 0.3));
`;

export const RowOpponentWhenTwoWrestlerInBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  & .opponent-name {
    font-size: 22px;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
    width: calc(100% - 10px);
    padding: 0 30px;
    text-align: center;
    letter-spacing: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &.row-opponent-left {
    padding-left: 80px;
  }

  &.row-opponent-right {
    padding-right: 80px;
    justify-content: flex-end;
  }
`;

export const BoxWhenFatalorTagMatchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 35%;
  gap: 30px;

  &.left {
    padding-left: 80px;
  }
`;

export const BoxThreeWrestlersContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 30px;
`;

export const BoxFourWrestlersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  width: calc(100% - 60px);
  gap: 30px;
`;

export const BoxFiveWrestlersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  width: calc(100% - 60px);
  gap: 30px;
`;

export const BoxSixWrestlersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: calc(100% - 60px);
  gap: 25px;
  padding: 0 30px;
`;

export const BoxSingleWrestlerContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 30px;
  align-items: center;
  gap: 10px;
  width: 35%;

  & .wrestler-name {
    font-size: 30px;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
    width: calc(100% - 200px);
    padding: 0 30px;
    text-align: center;
    letter-spacing: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const BoxSingleWrestlerWhenThreeWrestlerOnSide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  width: calc(100% - 30px);

  & .name-wrestler {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
    width: 100%;
    padding: 0 30px;
    letter-spacing: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.box-wrestler.right .name-wrestler,
  &.right .name-wrestler {
    text-align: right;
    justify-content: flex-end;
  }
`;

export const BoxWrestlerWhenFourOrUpperWrestlerOnSide = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  width: calc(50% - 30px);
  min-width: 120px;

  & .name-wrestler {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
    width: 100%;
    padding: 0 30px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.box-wrestler.right .name-wrestler {
    text-align: right;
    justify-content: flex-end;
  }
`;
